import { configureStore } from '@reduxjs/toolkit'
import { formReducer } from './slice/form'
import { decisionReducer } from './slice/decision'

export const reducer = {
  form: formReducer,
  decision: decisionReducer
}
export default configureStore({ reducer })